import { Mail, PhoneIcon } from 'lucide-react';
import React from 'react';
import { FaFacebook, FaInstagram, FaTelegram, FaWhatsapp, FaYoutube } from 'react-icons/fa';
import { FaTiktok } from 'react-icons/fa6';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-white border-t border-[#3E3274] py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex mb-4">
              <Link to="/" className="flex-shrink-0 group cursor-pointer">
                <div className="flex">
                  <div className="flex transform group-hover:scale-120">
                    <img src="/images/logo.png" alt="Kenzie Logo" className="h-12 w-auto flex group-hover:animate-softPulse" />
                  </div>
                </div>
              </Link>
            </div>
            <p className="text-slate-500 text-sm">
              Kenzie Komunika hadir sebagai pilihan terbaik untuk Prduk Online dan Produk Payment, membantu Anda berkembang dengan sistem yang stabil, harga kompetitif, dan dukungan penuh setiap saat.
            </p>
          </div>

          <div>
            <h4 className="text-slate-700 font-semibold mb-4">Pintasan Cepat</h4>
            <ul className="space-y-2">
              {[
                { name: 'Beranda', path: '/' },
                { name: 'Tentang Kami', path: '/about' },
                { name: 'Panduan', path: '/services' },
                { name: 'Media Promosi', path: '/portfolio' },
              ].map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link.path} 
                    className="text-slate-500 hover:text-blue-400 transition-colors duration-300 text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-slate-700 font-semibold mb-4">Office</h4>
            <p className='text-sm text-slate-500'>
              <Link to="https://maps.app.goo.gl/hbRTFza8GFnh3S8J8" target="_blank" className="flex-shrink-0 group cursor-pointer">Jl. Cijagra No.18C, Cijagra, Kec. Lengkong, Kota Bandung, Jawa Barat 40265</Link><br/>
              <Link to="tel:+622263175009" target="_blank" className="flex-shrink-0 group cursor-pointer">
                <div className='flex flex-row gap-2 mt-2'>
                  <PhoneIcon size={16}></PhoneIcon> +622263175009
                </div>
              </Link>
              <Link to="https://wa.me/628987897555" target="_blank" className="flex-shrink-0 group cursor-pointer">
                <div className='flex flex-row gap-2'>
                  <FaWhatsapp size={16}></FaWhatsapp> +628987897555
                </div>
              </Link>
              <Link to="mailto:admin@radarpulsa.com" target="_blank" className="flex-shrink-0 group cursor-pointer">
                <div className='flex flex-row gap-2'>
                  <Mail size={16}></Mail> admin@kenziekomunika.com
                </div>
              </Link>
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Ikuti Kami:</h4>
            <div className="flex space-x-2">
              <div className="relative group">
                <a 
                  href="https://www.facebook.com/people/Kenzie-Komunika-Official/61561765685120/" target="_blank"
                  className="w-10 h-10 bg-red-500 rounded-lg flex items-center justify-center hover:bg-gradient-to-br hover:from-red-500 hover:to-[#3E3274] transition-all duration-300 transform hover:scale-110"
                >
                  <span className="text-sm text-white font-semibold"><FaFacebook size={18}></FaFacebook></span>
                </a>
                <div className="absolute bottom-full mb-2 hidden group-hover:block w-32 p-2 text-sm text-white bg-gray-900 rounded-lg shadow-lg">
                  Official Facebook Kenzie Komunika
                </div>
              </div>
              <div className="relative group">
                <a
                  href="https://www.instagram.com/official_kenziekomunika/" target="_blank"
                  className="w-10 h-10 bg-red-500 rounded-lg flex items-center justify-center hover:bg-gradient-to-br hover:from-red-500 hover:to-[#3E3274] transition-all duration-300 transform hover:scale-110"
                >
                  <span className="text-sm text-white font-semibold"><FaInstagram size={18}></FaInstagram></span>
                </a>
                <div className="absolute bottom-full mb-2 hidden group-hover:block w-32 p-2 text-sm text-white bg-gray-900 rounded-lg shadow-lg">
                  Official Instagram Kenzie Komunika
                </div>
              </div>
              <div className="relative group">
                <a
                  href="#" target="_blank"
                  className="w-10 h-10 bg-red-500 rounded-lg flex items-center justify-center hover:bg-gradient-to-br hover:from-red-500 hover:to-[#3E3274] transition-all duration-300 transform hover:scale-110"
                >
                  <span className="text-sm text-white font-semibold"><FaYoutube size={18}></FaYoutube></span>
                </a>
                <div className="absolute bottom-full mb-2 hidden group-hover:block w-32 p-2 text-sm text-white bg-gray-900 rounded-lg shadow-lg">
                  Official Youtube Channel Kenzie Komunika
                </div>
              </div>
              <div className="relative group">
                <a
                  href="https://www.tiktok.com/@kenziekomunika.official" target="_blank"
                  className="w-10 h-10 bg-red-500 rounded-lg flex items-center justify-center hover:bg-gradient-to-br hover:from-red-500 hover:to-[#3E3274] transition-all duration-300 transform hover:scale-110"
                >
                  <span className="text-sm text-white font-semibold"><FaTiktok size={18}></FaTiktok></span>
                </a>
                <div className="absolute bottom-full mb-2 hidden group-hover:block w-32 p-2 text-sm text-white bg-gray-900 rounded-lg shadow-lg">
                  Tiktok Kenzie Komunika
                </div>
              </div>
            </div>
            <div className="flex space-x-2 pt-2">
              <div className="relative group">
                <a
                  href="https://t.me/KenzieKomunika" target="_blank"
                  className="w-10 h-10 bg-red-500 rounded-lg flex items-center justify-center hover:bg-gradient-to-br hover:from-red-500 hover:to-[#3E3274] transition-all duration-300 transform hover:scale-110"
                >
                  <span className="text-sm text-white font-semibold"><FaTelegram size={18}></FaTelegram></span>
                </a>
                <div className="absolute bottom-full mb-2 hidden group-hover:block w-32 p-2 text-sm text-white bg-gray-900 rounded-lg shadow-lg">
                  Telegram Kenzie Komunika
                </div>
              </div>
              <div className="relative group">
                <a
                  href="https://wa.me/6285795705113" target="_blank"
                  className="w-10 h-10 bg-red-500 rounded-lg flex items-center justify-center hover:bg-gradient-to-br hover:from-red-500 hover:to-[#3E3274] transition-all duration-300 transform hover:scale-110"
                >
                  <span className="text-sm text-white font-semibold"><FaWhatsapp size={18}></FaWhatsapp></span>
                </a>
                <div className="absolute bottom-full mb-2 hidden group-hover:block w-32 p-2 text-sm text-white bg-gray-900 rounded-lg shadow-lg">
                  Whatsapp 1
                </div>
              </div>
              <div className="relative group">
                <a
                  href="https://wa.me/6282269500400" target="_blank"
                  className="w-10 h-10 bg-red-500 rounded-lg flex items-center justify-center hover:bg-gradient-to-br hover:from-red-500 hover:to-[#3E3274] transition-all duration-300 transform hover:scale-110"
                >
                  <span className="text-sm text-white font-semibold"><FaWhatsapp size={18}></FaWhatsapp></span>
                </a>
                <div className="absolute bottom-full mb-2 hidden group-hover:block w-32 p-2 text-sm text-white bg-gray-900 rounded-lg shadow-lg">
                  Whatsapp 2
                </div>
              </div><div className="relative group">
                <a
                  href="https://wa.me/6281221433521" target="_blank"
                  className="w-10 h-10 bg-red-500 rounded-lg flex items-center justify-center hover:bg-gradient-to-br hover:from-red-500 hover:to-[#3E3274] transition-all duration-300 transform hover:scale-110"
                >
                  <span className="text-sm text-white font-semibold"><FaWhatsapp size={18}></FaWhatsapp></span>
                </a>
                <div className="absolute bottom-full mb-2 hidden group-hover:block w-32 p-2 text-sm text-white bg-gray-900 rounded-lg shadow-lg">
                  Whatsapp 3
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 text-center">
          <p className="text-gray-400 text-sm">
            © 2026 Putra Jaya Telesindo. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
